export default "__VITE_ASSET__BdWAJtDW__"